import { About } from "./about/About";
import { Features } from "./features/Features";
import { Contacts } from "./contacts/Contacts";
import styles from "./styles.module.scss";
import { useRef } from "react";
import { MainScreen } from "./mainScreen/MainScreen";
import { Button } from "components/frontComponents/button/Button";
import { useNavigate } from "react-router-dom";
import { RouterPathEnum } from "shared/enums/commonEnums";
import { useActiveSection } from "../../hooks/useActiveSection";
import { SupportPage } from "pages/supportPage/SupportPage";
// import { MealKBGUPage } from "pages/MealKBGU/MealKBGUPage";
// import { WeekKBGUPage } from "pages/weekKBGU/WeekKBGUPage";
// import KbguEvaluationPage from "pages/KbguEvaluationPage/KbguEvaluationPage";
// import { PersonalAccountFirstPage } from "pages/PersonalAccuntFirstPage/PersonalAccountFirstPage";

export interface ScrollPageProps {
  scrollToRef: (ref: React.RefObject<HTMLElement>) => void;
  aboutRef: React.RefObject<HTMLElement>;
  mainRef: React.RefObject<HTMLElement>;
  featuresRef: React.RefObject<HTMLElement>;
  contactsRef: React.RefObject<HTMLElement>;
  activeSection: string;
}

export const FirstPage = () => {
  const navigate = useNavigate();
  const AboutRef = useRef<HTMLElement>(null);
  const FeaturesRef = useRef<HTMLElement>(null);
  const ContactRef = useRef<HTMLElement>(null);
  const MainRef = useRef<HTMLElement>(null);

  //рефы для передачи в хук
  const sectionRefs = {
    Главная: MainRef,
    "О нас": AboutRef,
    Компоненты: FeaturesRef,
    Контакты: ContactRef,
  };

  // Используем хук для отслеживания активной секции
  const activeSection = useActiveSection(sectionRefs);

  const scrollToRef = (ref: React.RefObject<HTMLElement>) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <section ref={MainRef}>
        <MainScreen
          scrollToRef={scrollToRef}
          aboutRef={AboutRef}
          featuresRef={FeaturesRef}
          contactsRef={ContactRef}
          mainRef={MainRef}
          activeSection={activeSection}
        />
      </section>
      <section className={styles.section} ref={AboutRef}>
        <About
          scrollToRef={scrollToRef}
          mainRef={MainRef}
          featuresRef={FeaturesRef}
          contactsRef={ContactRef}
          aboutRef={AboutRef}
          activeSection={activeSection}
        />
        <Button
          viewVariant="crossed"
          className={styles.position}
          text="Результаты"
          onClick={() => navigate(RouterPathEnum.Auth)}
        />
      </section>
      <section className={styles.section} ref={FeaturesRef}>
        <Features
          scrollToRef={scrollToRef}
          mainRef={MainRef}
          aboutRef={AboutRef}
          contactsRef={ContactRef}
          featuresRef={FeaturesRef}
          activeSection={activeSection}
        />
        <Button
          viewVariant="crossed"
          className={styles.position1}
          text="Результаты"
          onClick={() => navigate(RouterPathEnum.Auth)}
        />
      </section>
      <section className={styles.section}>
        <SupportPage />
      </section>
      <section className={styles.section} ref={ContactRef}>
        <Contacts
          scrollToRef={scrollToRef}
          mainRef={MainRef}
          featuresRef={FeaturesRef}
          aboutRef={AboutRef}
          contactsRef={ContactRef}
          activeSection={activeSection}
        />
      </section>
      {/* <MealKBGUPage />
      <WeekKBGUPage />
      <KbguEvaluationPage />
      <PersonalAccountFirstPage /> */}
    </>
  );
};
